// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-8dabc003] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.dashboard-widget[data-v-8dabc003] .empty-content {
  text-align: center;
  padding-top: 5vh;
}
.dashboard-widget[data-v-8dabc003] .empty-content.half-screen {
  padding-top: 0;
  margin-bottom: 1vh;
}
.more[data-v-8dabc003] {
  display: block;
  text-align: center;
  color: var(--color-text-maxcontrast);
  line-height: 60px;
  cursor: pointer;
}
.more[data-v-8dabc003]:hover, .more[data-v-8dabc003]:focus {
  background-color: var(--color-background-hover);
  border-radius: var(--border-radius-element);
  color: var(--color-main-text);
}

/* skeleton */
.item-list__entry[data-v-8dabc003] {
  display: flex;
  align-items: flex-start;
  padding: 8px;
}
.item-list__entry .item-avatar[data-v-8dabc003] {
  position: relative;
  margin-block: auto;
  background-color: var(--color-background-dark) !important;
}
.item-list__entry .item__details[data-v-8dabc003] {
  padding-inline-start: 8px;
  max-height: var(--default-clickable-area);
  flex-grow: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.item-list__entry .item__details h3[data-v-8dabc003],
.item-list__entry .item__details .message[data-v-8dabc003] {
  white-space: nowrap;
  background-color: var(--color-background-dark);
}
.item-list__entry .item__details h3[data-v-8dabc003] {
  font-size: 100%;
  margin: 0;
}
.item-list__entry .item__details .message[data-v-8dabc003] {
  width: 80%;
  height: 15px;
  margin-top: 5px;
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/dialogs/node_modules/@nextcloud/vue/dist/assets/NcDashboardWidget-nZuIL1UN.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,oCAAoC;EACpC,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,+CAA+C;EAC/C,2CAA2C;EAC3C,6BAA6B;AAC/B;;AAEA,aAAa;AACb;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yDAAyD;AAC3D;AACA;EACE,yBAAyB;EACzB,yCAAyC;EACzC,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;AACA;;EAEE,mBAAmB;EACnB,8CAA8C;AAChD;AACA;EACE,eAAe;EACf,SAAS;AACX;AACA;EACE,UAAU;EACV,YAAY;EACZ,eAAe;AACjB","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-8dabc003] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.dashboard-widget[data-v-8dabc003] .empty-content {\n  text-align: center;\n  padding-top: 5vh;\n}\n.dashboard-widget[data-v-8dabc003] .empty-content.half-screen {\n  padding-top: 0;\n  margin-bottom: 1vh;\n}\n.more[data-v-8dabc003] {\n  display: block;\n  text-align: center;\n  color: var(--color-text-maxcontrast);\n  line-height: 60px;\n  cursor: pointer;\n}\n.more[data-v-8dabc003]:hover, .more[data-v-8dabc003]:focus {\n  background-color: var(--color-background-hover);\n  border-radius: var(--border-radius-element);\n  color: var(--color-main-text);\n}\n\n/* skeleton */\n.item-list__entry[data-v-8dabc003] {\n  display: flex;\n  align-items: flex-start;\n  padding: 8px;\n}\n.item-list__entry .item-avatar[data-v-8dabc003] {\n  position: relative;\n  margin-block: auto;\n  background-color: var(--color-background-dark) !important;\n}\n.item-list__entry .item__details[data-v-8dabc003] {\n  padding-inline-start: 8px;\n  max-height: var(--default-clickable-area);\n  flex-grow: 1;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n.item-list__entry .item__details h3[data-v-8dabc003],\n.item-list__entry .item__details .message[data-v-8dabc003] {\n  white-space: nowrap;\n  background-color: var(--color-background-dark);\n}\n.item-list__entry .item__details h3[data-v-8dabc003] {\n  font-size: 100%;\n  margin: 0;\n}\n.item-list__entry .item__details .message[data-v-8dabc003] {\n  width: 80%;\n  height: 15px;\n  margin-top: 5px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
